import { render, staticRenderFns } from "./patient-card.vue?vue&type=template&id=52bb0058&scoped=true"
import script from "./patient-card.vue?vue&type=script&lang=ts"
export * from "./patient-card.vue?vue&type=script&lang=ts"
import style0 from "./patient-card.vue?vue&type=style&index=0&id=52bb0058&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52bb0058",
  null
  
)

export default component.exports